export function Logo({ className = "h-10", withText = false }) {
  return (
    <div className="flex items-center gap-3">
      <img
        src="/brand/infosecgig.png"
        alt="InfosecGig Academy"
        className={`${className} object-contain rounded-md bg-white p-1`}
        data-testid="brand-logo"
      />
      {withText && (
        <span className="font-heading font-bold text-lg hidden sm:block">
          InfosecGig <span className="text-[#F26522]">Academy</span>
        </span>
      )}
    </div>
  );
}

export function AironixBadge({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 text-slate-400 text-xs ${className}`}>
      <span>An initiative of</span>
      <img src="/brand/aironix.png" alt="Aironix" className="h-6 object-contain" data-testid="aironix-logo" />
    </div>
  );
}

export function Spinner({ label }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-slate-400" data-testid="loading-spinner">
      <div className="h-8 w-8 rounded-full border-2 border-white/10 border-t-[#F26522] animate-spin" />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}

export function LevelBadge({ level }) {
  return (
    <span className="chip bg-[#F26522]/15 text-[#F26522] font-semibold">
      LVL {level}
    </span>
  );
}
